import React from "react";
import PropTypes from "prop-types";
import "./SplitButtonCascade.scss";

/**
 * Cascade, multi-level dropdown for SplitButton
 * @param {object} item - item with nested items
 */
const SplitButtonCascadeComponent = (props) => {
  return (
    <>
      <span
        className={`k-icon k-i-arrow-chevron-${
          props.item.direction ?? "right"
        }`}
        data-tooltip=""
      ></span>
      <span className="k-menu-link-text" data-tooltip="">
        {props.item.text}
      </span>

      <ul
        className={`split-button-cascade ${props.item.direction ?? "right"}`}
        data-tooltip=""
      >
        {props.item.items.map((x, index) => {
          return (
            <li
              key={index}
              className="k-item k-menu-item"
              role="menuitem"
              onClick={() => props.item.onItemClick(index, x)}
              data-tooltip=""
            >
              <span
                tabIndex="-1"
                className={`k-link k-menu-link${
                  x.disabled ? " k-disabled" : ""
                }`}
                data-tooltip=""
              >
                <img
                  role="presentation"
                  alt=""
                  src={x.imageUrl}
                  className="k-icon"
                  data-tooltip=""
                />
                <span className="k-menu-link-text" data-tooltip="">
                  {x.text}
                </span>
              </span>
            </li>
          );
        })}
      </ul>
    </>
  );
};

SplitButtonCascadeComponent.propTypes = {
  item: PropTypes.shape({
    direction: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
    text: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        text: PropTypes.string,
        imageUrl: PropTypes.string,
      })
    ),
  }),
};

export default SplitButtonCascadeComponent;
